import { Link } from "react-router-dom";
import { topics } from "@/mocks/videos";

export default function TopicCollections() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="mb-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 flex items-center gap-2">
          <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
          推荐专题合集
        </h2>
        <p className="text-sm text-foreground-600 mt-2">编辑精选的主题片单，一次看个够</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to={`/search?query=${encodeURIComponent(topic.title)}`}
            className="group relative h-52 md:h-60 rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src={topic.cover}
              alt={`${topic.title}专题封面`}
              title={`${topic.title} - 69视频专题`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <div className="flex items-center gap-2 mb-2 flex-wrap">
                {topic.tags.map((tag) => (
                  <span key={tag} className="px-2 py-0.5 rounded-full bg-background-50/20 text-background-50 text-xs border border-background-100/25">
                    {tag}
                  </span>
                ))}
              </div>
              <h3 className="font-heading font-bold text-xl text-background-50 mb-1">{topic.title}</h3>
              <p className="text-sm text-background-100/85">{topic.subtitle}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}